import { InputHTMLAttributes } from "react";
import { Accordion, Form } from "react-bootstrap";
import { NoData, Spinner } from "@whitespace/whitespace-ui";
import IGroup from "interfaces/models/IGroup";

interface GroupsFilterProps extends InputHTMLAttributes<HTMLInputElement> {
  register: any;
  accordionKey: string;
  hasFilterChanged : boolean;
  groups: IGroup[];
  handleOnChange? : () => void;
}

const GroupsFilter : React.FC<GroupsFilterProps> = ({
  register, accordionKey, hasFilterChanged, groups, handleOnChange
} : GroupsFilterProps) => {
  const renderGroups = () => groups.map((group : IGroup) => (
    <Form.Check
      {...register("group")}
      key={`group${group.groupId}`}
      id={`group${group.groupId}`}
      data-testid={`group${group.groupId}`}
      name="group"
      type="checkbox"
      label={`${group.groupName}`}
      value={group.groupId}
      className="left-margin-medium"
      onInput={handleOnChange}
    />
  ));

  return (
    <>
      <Accordion key={accordionKey} defaultActiveKey={hasFilterChanged ? "accordionGroups" : ""}>
        <Accordion.Item eventKey="accordionGroups">
          <Accordion.Header>
            Groups
            <Spinner className="left-margin-small" animation="grow" visible={false} spinnerText="Loading" variant="info" />
          </Accordion.Header>
          <Accordion.Body>
            <section>
              <Form.Group controlId="groups">
                {groups.length > 0 && renderGroups()}
                <NoData visible={groups.length === 0} description="No Groups found." />
              </Form.Group>
            </section>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default GroupsFilter;
